import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["slug", "eventSlug", "srtrev"];
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { bannerContainerGetServerSideProps } from "@catchoftheday/catalogue";
import { getEnvConfig } from "@catchoftheday/env-config";
import { ServerGQLClient } from "@catchoftheday/graphql-utils";
import { idFromSlug } from "@catchoftheday/product-components";
import { serializeQueryString } from "@catchoftheday/utilities";
import { EventBreadcrumbDocument, ProductByIdDocument } from "../../../generated/graphql";

function return404() {
  return {
    notFound: true,
    props: {
      data: null
    }
  };
}

var is404 = function is404(error) {
  var _error$graphQLErrors;

  if (!(error !== null && error !== void 0 && (_error$graphQLErrors = error.graphQLErrors) !== null && _error$graphQLErrors !== void 0 && _error$graphQLErrors.length)) return false;
  var graphQLErrors = error.graphQLErrors;
  var is404Error = graphQLErrors.some(function (error) {
    var _error$extensions, _error$extensions$res;

    return ((_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : (_error$extensions$res = _error$extensions.response) === null || _error$extensions$res === void 0 ? void 0 : _error$extensions$res.status) === 404;
  });
  return is404Error;
};

var onePassProductIds = ["1", "4", "5"];
var defaultEventId = "1";
export function productPageRequest(_x, _x2, _x3) {
  return _productPageRequest.apply(this, arguments);
}

function _productPageRequest() {
  _productPageRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(query, req, res) {
    var _eventBySlugResult$da, _scheduledBannerResul, _scheduledBannerResul2, _scheduledBannerResul3;

    var slug, eventSlug, srtrev, queryParams, offerId, previewHash, queryParamString, client, productId, eventId, isInvalidProductId, productById, eventBySlug, _yield$Promise$all, _yield$Promise$all2, productByIdResult, eventBySlugResult, scheduledBannerResult, data, product, nullEvent, _eventBySlugResult$da2, _eventBySlugResult$da3, trueEventSlug;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!res.headersSent) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", {
              props: {
                data: null
              }
            });

          case 2:
            slug = query.slug, eventSlug = query.eventSlug, srtrev = query.srtrev, queryParams = _objectWithoutProperties(query, _excluded);
            offerId = queryParams.offer_id, previewHash = queryParams.preview_hash;
            queryParamString = "?".concat(serializeQueryString(queryParams));
            client = new ServerGQLClient({
              uri: getEnvConfig().GRAPHQL_ENDPOINT,
              headers: req.headers
            });
            productId = idFromSlug(slug);
            eventId = eventSlug ? idFromSlug(eventSlug) : null;
            isInvalidProductId = productId == "";
            /*
              Return 404 before making network requests if
              1. Product id is not valid
              2. Connection is not closed
            */

            if (!(isInvalidProductId && req.headers.connection !== "close")) {
              _context3.next = 11;
              break;
            }

            return _context3.abrupt("return", return404());

          case 11:
            productById = /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return client.query({
                          query: ProductByIdDocument,
                          variables: {
                            productId: productId,
                            selectedOfferId: offerId,
                            previewHash: previewHash
                          },
                          headers: srtrev ? {
                            srtrev: srtrev
                          } : undefined
                        });

                      case 3:
                        return _context.abrupt("return", _context.sent);

                      case 6:
                        _context.prev = 6;
                        _context.t0 = _context["catch"](0);
                        return _context.abrupt("return", {
                          error: _context.t0
                        });

                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0, 6]]);
              }));

              return function productById() {
                return _ref.apply(this, arguments);
              };
            }();

            eventBySlug = eventSlug && eventId ? /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.prev = 0;
                      _context2.next = 3;
                      return client.query({
                        query: EventBreadcrumbDocument,
                        variables: {
                          slug: eventSlug
                        }
                      });

                    case 3:
                      return _context2.abrupt("return", _context2.sent);

                    case 6:
                      _context2.prev = 6;
                      _context2.t0 = _context2["catch"](0);
                      return _context2.abrupt("return", {
                        error: _context2.t0
                      });

                    case 9:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, null, [[0, 6]]);
            })) : null;
            _context3.next = 15;
            return Promise.all([productById(), eventBySlug === null || eventBySlug === void 0 ? void 0 : eventBySlug(), bannerContainerGetServerSideProps(client)]);

          case 15:
            _yield$Promise$all = _context3.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
            productByIdResult = _yield$Promise$all2[0];
            eventBySlugResult = _yield$Promise$all2[1];
            scheduledBannerResult = _yield$Promise$all2[2];

            if (!(productByIdResult.error || eventBySlugResult !== null && eventBySlugResult !== void 0 && eventBySlugResult.error)) {
              _context3.next = 22;
              break;
            }

            return _context3.abrupt("return", is404(productByIdResult.error) || is404(eventBySlugResult === null || eventBySlugResult === void 0 ? void 0 : eventBySlugResult.error) ? return404() : {
              props: {
                data: null,
                hasError: true,
                slug: slug,
                eventSlug: eventSlug || null
              }
            });

          case 22:
            data = productByIdResult.data;
            product = data === null || data === void 0 ? void 0 : data.productById; // Valid event slug but no event found

            nullEvent = (eventBySlugResult === null || eventBySlugResult === void 0 ? void 0 : (_eventBySlugResult$da = eventBySlugResult.data) === null || _eventBySlugResult$da === void 0 ? void 0 : _eventBySlugResult$da.eventBySlug.event) === null;

            if (!(req.headers.connection === "close")) {
              _context3.next = 27;
              break;
            }

            return _context3.abrupt("return", {
              props: {
                data: null
              }
            });

          case 27:
            if (!(product && onePassProductIds.includes(product.id))) {
              _context3.next = 29;
              break;
            }

            return _context3.abrupt("return", {
              redirect: {
                destination: "/onepass",
                permanent: true
              }
            });

          case 29:
            if (!(product && eventSlug && eventBySlugResult)) {
              _context3.next = 33;
              break;
            }

            trueEventSlug = (_eventBySlugResult$da2 = eventBySlugResult.data) === null || _eventBySlugResult$da2 === void 0 ? void 0 : (_eventBySlugResult$da3 = _eventBySlugResult$da2.eventBySlug.event) === null || _eventBySlugResult$da3 === void 0 ? void 0 : _eventBySlugResult$da3.slug;

            if (!(trueEventSlug && (eventSlug !== trueEventSlug || product.slug !== slug) && eventId !== defaultEventId)) {
              _context3.next = 33;
              break;
            }

            return _context3.abrupt("return", {
              redirect: {
                destination: "/event/".concat(trueEventSlug, "/product/").concat(product.slug, "/").concat(queryParamString),
                permanent: true
              }
            });

          case 33:
            if (!(product && (product.slug !== slug || eventId == defaultEventId || eventId == "" || nullEvent))) {
              _context3.next = 35;
              break;
            }

            return _context3.abrupt("return", {
              redirect: {
                destination: "/product/".concat(product.slug, "/").concat(queryParamString),
                // if on event url 301 else 307
                permanent: !eventSlug
              }
            });

          case 35:
            return _context3.abrupt("return", {
              props: {
                data: data || null,
                offerId: offerId || null,
                slug: slug,
                eventSlug: eventSlug || null,
                banners: scheduledBannerResult === null || scheduledBannerResult === void 0 ? void 0 : (_scheduledBannerResul = scheduledBannerResult.scheduledBanners) === null || _scheduledBannerResul === void 0 ? void 0 : (_scheduledBannerResul2 = _scheduledBannerResul.data) === null || _scheduledBannerResul2 === void 0 ? void 0 : (_scheduledBannerResul3 = _scheduledBannerResul2.bannerByPage) === null || _scheduledBannerResul3 === void 0 ? void 0 : _scheduledBannerResul3.banners
              }
            });

          case 36:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _productPageRequest.apply(this, arguments);
}